import { RoundedBox } from "@knowfully/ui.common";
import { Box, CircularProgress, Theme, useTheme } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import { CourseDetailsRequest } from "services/organizationPortalClient";

const useStyles = (theme: Theme) => ({
  progress: {
    textAlign: "center",
  },
  container: {
    display: "grid",
    mb: 2,
  },
});

type CourseDetailsSummaryProps = {
  skuId: string;
  isSeries?: boolean;
};

export function CourseDetailsSummary({
  skuId,
  isSeries = false,
}: CourseDetailsSummaryProps) {
  const styles = useStyles(useTheme());
  const { courseService } = useGlobalContext();

  const { data, isFetching } = useQuery(["course-details-summary", skuId], () =>
    courseService.getCourseDetailsSummary(
      CourseDetailsRequest.fromJS({
        skuId: skuId,
        isSeries: isSeries,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })
    )
  );

  return (
    <>
      {isFetching ? (
        <RoundedBox sx={styles.progress}>
          <CircularProgress />
        </RoundedBox>
      ) : (
        <Box sx={styles.container}>
          <span
            dangerouslySetInnerHTML={{
              __html: data?.value!,
            }}
          ></span>
        </Box>
      )}
    </>
  );
}
